import { useEffect, useState } from 'react';
/**
 * When the component unmount we will animate its
 * way out. During this animation it should
 * still be visible even if it declared as "unmounted"
 */
export const useVisibility = (isDeclaredMounted, delay) => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        let timeoutId;
        if (isDeclaredMounted) {
            setIsVisible(true);
        }
        else if (!isDeclaredMounted) {
            timeoutId = setTimeout(() => setIsVisible(false), delay);
        }
        return () => {
            clearTimeout(timeoutId);
        };
    }, [isDeclaredMounted, delay]);
    return isVisible;
};
